module.exports = __webpack_public_path__ + "img/Shop.956f220b.gif";